export default {
  M: 'Male',
  F: 'Female'
}